module.exports = __webpack_public_path__ + "img/star.533b5102.svg";